
        import * as THREE from 'three'
        import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
        // import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
        import { Rhino3dmLoader } from 'three/examples/jsm/loaders/3DMLoader.js';
        import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
        // import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js';
        import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';
        let cachedGLTF = null;
        // import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
        // import { ArcballControls } from 'three/examples/jsm/controls/ArcballControls.js';
        // import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls.js';
        // import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js';
        // import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls.js';


        // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
        // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
        // import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass.js';
        // import { SAOPass } from 'three/examples/jsm/postprocessing/SAOPass.js';
        // import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';
        // import {TAARenderPass} from 'three/examples/jsm/postprocessing/TAARenderPass.js';
        

        import gsap from "gsap";

        let directionalLight;
        let loadedPercentage;
        let doneOnce=false;

        let isAnimating = false;

        let composer;
        let scene, camera, renderer, controls;
        let raycaster, mouse;
        let currentlySelectedStep = 0;

        let isFPSMode = false; // Toggle between OrbitControls and FPS mode
        let prevMouseX = 0, prevMouseY = 0;
        let deltaX = 0, deltaY = 0;
        const sensitivity = 0.002; // Mouse sensitivity
        let isControlling = false;

        let directionVector;
        let newTarget;

        let cameraPosition;
        let controlsTarget;

        let originalControlsType = "Orbit";
        let newControlsType;

        let modelLoaded = false;
        const markers = [];
        const leftArrowSteps = document.getElementById("leftArrowSteps");
        const rightArrowSteps = document.getElementById("rightArrowSteps");


        const raycasterHover = new THREE.Raycaster();
        const mouseHover = new THREE.Vector2();
        let hoveredMarker = null;
    
        let markersHiddenViaClick = false;

        let CLTMaterial;
        let hardwoodMaterial;

        const textureLoader = new THREE.TextureLoader();
        const woodTexture = textureLoader.load('textures/Plywood_vdcjecc_4K_BaseColor_PS.jpg'); // Use your texture path here
        woodTexture.encoding = THREE.sRGBEncoding; // Ensure correct color space
        woodTexture.wrapS = THREE.RepeatWrapping;
        woodTexture.wrapT = THREE.RepeatWrapping;

        const woodTextureDark = textureLoader.load('textures/Plywood_vdcjecc_4K_BaseColor_PS_darker.jpg'); // Use your texture path here
        woodTextureDark.encoding = THREE.sRGBEncoding; // Ensure correct color space
        woodTextureDark.wrapS = THREE.RepeatWrapping;
        woodTextureDark.wrapT = THREE.RepeatWrapping;

        const woodCLT = textureLoader.load('textures/CLT_UPDATED.jpg'); // Use your texture path here
        woodCLT.encoding = THREE.sRGBEncoding; // Ensure correct color space
        woodCLT.wrapS = THREE.RepeatWrapping;
        woodCLT.wrapT = THREE.RepeatWrapping;

        const woodCLTDark = textureLoader.load('textures/CLT_UPDATED_darker.jpg'); // Use your texture path here
        woodCLTDark.encoding = THREE.sRGBEncoding; // Ensure correct color space
        woodCLTDark.wrapS = THREE.RepeatWrapping;
        woodCLTDark.wrapT = THREE.RepeatWrapping;

        const woodCLTSide = textureLoader.load('textures/CLT_side_seamless_UPDATED.jpg'); // Use your texture path here
        woodCLTSide.encoding = THREE.sRGBEncoding; // Ensure correct color space
        woodCLTSide.wrapS = THREE.RepeatWrapping;
        woodCLTSide.wrapT = THREE.RepeatWrapping;




        let modelSteps = [
            {
                name:"step0",
                title:"Ontdek de kracht van CLT – van wijk tot werkbank.",
                textDesription:"Klik op een bolletje in beeld of onderin – of volg de route met de pijltjes en ontdek jouw nieuwe CLT-project.",
                cameraPosition: {x: 47.00000000000002,y:59.999999999999986,z:-94},
                controlsTarget: {x: 0,y:0,z: 0},
                controlsType:"Orbit",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:false,
                menu:"NoMenus",
                sunDirection:{
                    x:78,
                    y:50,
                    z:121
                }



            },
            {
                name:"step1",
                title:"Welkom bij CLTopmaat – hét platform dat bouwen met hout toegankelijk maakt.",
                textDesription:"Upload je ontwerp, kies een pakket, ontvang een offerte. Zo simpel is het.",
                cameraPosition: {x: 38.77047618229759, y: 2.0879506750274133, z: -12.912342706486232},
                controlsTarget: {x: 34.579944308784846, y: 1.4099999999999993, z: 6.043964615614495},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:true,
                menu:"RightMenu",
                sunDirection:{
                    x:200,
                    y:120,
                    z:-140
                }            

            },
            {
                name:"step2",
                title:"CLT voor meer dan alleen bouwen – ontdek onze meubels en objecten.",
                textDesription:"Elk product in onze webshop is duurzaam, slim ontworpen en eenvoudig te monteren.",
                cameraPosition: {x: 35.60789016710032, y: 2.1, z: 3.8917757691969816},
                controlsTarget: {x: 19.977915206763797, y: 1.75, z: 6.337077696083107},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:false,
                menu:"RightMenu",
                sunDirection:{
                    x:97,
                    y:50,
                    z:-105,
                }

            },
            {
                name:"step3",
                title:"Jouw woning. Volledig in CLT.",
                textDesription:"Van gevels tot vloeren – CLT geeft je ontwerp warmte, structuur en duurzaamheid.",
                cameraPosition: {x: -14.792448269233166, y: 14.793895023431642, z: -2.433324229001915},
                controlsTarget: {x: -4.84330640293359, y: -2.0939322157141758e-16, z: 26.021673193790967},
                controlsType:"Orbit",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"HiddingObjects",
                mainStep:true,
                menu:"LeftMenu",
                sunDirection:{
                    x:200,
                    y:120,
                    z:-140
                }

            },
            {
                name:"step4",
                title:"Een trap van massief hout, slim ontworpen in CLT.",
                textDesription:"Lichtgewicht waar het kan, robuust waar nodig – wij denken met je mee.",
                cameraPosition: {x:-0.9026940297646906,y:2.3,z:4.059146207520875},
                controlsTarget: {x: -8.919137460741569, y:2.3, z: 30.043819417766997},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"HiddingObjects",
                mainStep:false,
                menu:"LeftMenu",
                sunDirection:{
                    x:200,
                    y:120,
                    z:-140
                }

            },
            {
                name:"step5",
                title:"Het hart van je woning – volledig op maat ontworpen in CLT.",
                textDesription:"Ingebouwde oplossingen met karakter. Upload je ontwerp – wij regelen de rest.",
                cameraPosition: {x: -6.24268869594117, y: 1.5219571435016169, z: 12.029945390728523},
                controlsTarget: {x: -8.48770518881772, y: 1.5219571435016169, z: 26.58326838310521},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"HiddingObjects",
                mainStep:false,
                menu:"RightMenu",
                sunDirection:{
                    x:-8,
                    y:20,
                    z:-57
                }

            },
            {
                name:"step6",
                title:"CLT als interieurstatement – dineren, vergaderen, leven.",
                textDesription:"Van kruk tot vergadertafel – elke plank vertelt jouw verhaal.",
                cameraPosition: {x: -7.927652701016356, y: 1.5219571435016169, z: 14.854549827340854},
                controlsTarget: {x: -9.839491244192264, y: 1.5219571435016169, z: 35.89611527803327},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:false,
                menu:"RightMenu",
                sunDirection:{
                    x:-121,
                    y:40,
                    z:63
                }

            },
            {
                name:"step7",
                title:"CLT in de keuken – natuurlijk, strak, functioneel.",
                textDesription:"Combineer robuust hout met modern comfort. Klaar om in te bouwen.",
                cameraPosition: {x: -10.087005593581663, y: 1.5219571435016169, z: 18.933822485234423},
                controlsTarget: {x: -1.635598652023709, y: 1.5219571435016169, z: 21.502909443354756},
                controlsType:"FirstPerson",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:false,
                menu:"LeftMenu",
                sunDirection:{
                    x:-121,
                    y:40,
                    z:63
                }

            },
            {
                name:"step8a",
                title:"Een plek voor jou alleen – schrijf, schilder, werk of droom in jouw CLT-hut.",
                textDesription:"Altijd uniek. Altijd op maat.",
                cameraPosition: {x:-14.364629743738227,y:1.6,z:30.758382932094143},
                controlsTarget: {x: 4.8259588853246855, y: 1.6, z:45},
                controlsType:"Orbit",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"AdjustMaterial",
                mainStep:false,
                menu:"LeftMenu",
                sunDirection:{
                    x:200,
                    y:120,
                    z:-140
                }

            },
            {
                name:"step8",
                title:"CLT maakt ruimte voor jouw ideeën – op maat en in stijl.",
                textDesription:"Wat zou jij ervan maken?",
                cameraPosition: {x:5.726577269424378,y:19.504523206628882,z:18.796678081469242},
                controlsTarget: {x: -2.8171559999999998, y: 0, z: 44.48498699999999},
                controlsType:"Orbit",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"AdjustMaterial",
                mainStep:true,
                menu:"LeftMenu",
                sunDirection:{
                    x:200,
                    y:120,
                    z:-140
                }

            },
            {
                name:"step9",
                title:"CLT is dichterbij dan je denkt – en begint bij één klik.",
                textDesription:"Start jouw project vandaag via CLTopmaat.nl",
                cameraPosition: {x: 89.06474316951369, y: 50.5200581644407, z: -42.18070581226786},
                controlsTarget: {x: 0, y: 0, z: 0  },
                controlsType:"Orbit",
                interpolateNext:false,
                interpolateNextPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                interpolatePrevious:false,
                interpolatePreviousPoint:{
                    cameraPosition: {x: 0,y:0,z:0},
                    controlsTarget: {x: 0,y:0,z:0},
                },
                specialFunction:"None",
                mainStep:true,
                menu:"LeftMenu",
                sunDirection:{
                    x:78,
                    y:80,
                    z:121
                }

            },
        ]

        THREE.Cache.enabled = true;
        


        function init() {
            // Get the target container
            const container = document.getElementById("canvas");

            // Scene
            scene = new THREE.Scene();
            scene.background = new THREE.Color(0xffffff);

            // Camera
            camera = new THREE.PerspectiveCamera(50, container.clientWidth / container.clientHeight, 0.5, 300);
            camera.updateProjectionMatrix();


            // camera.near = 0.5;   // Set near plane to 0.1
            // camera.far = 500; 
            // camera.updateProjectionMatrix();

            camera.position.set(47, 60, -94);

            // Renderer
            renderer = new THREE.WebGLRenderer({ antialias: true, precision: 'highp',logarithmicDepthBuffer: true});
            // logarithmicDepthBuffer: true

            // renderer.outputEncoding = THREE.sRGBEncoding;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            // renderer.toneMapping = THREE.NoToneMapping;
            renderer.toneMappingExposure = 1.0;
            // renderer.physicallyCorrectLights = true;

            renderer.setSize(container.clientWidth, container.clientHeight);

            renderer.shadowMap.enabled = true;  // ✅ Enable shadows
            renderer.shadowMap.type = THREE.PCFSoftShadowMap; // Softer shadows
            

            container.appendChild(renderer.domElement);

            // Controls - orbit
            
            controls = new OrbitControls(camera, renderer.domElement);
            controls.enableDamping = true;
            

            // Prevent camera from looking below ground
            controls.minPolarAngle = THREE.MathUtils.degToRad(20); 
            controls.maxPolarAngle = THREE.MathUtils.degToRad(88); // Prevents camera from flipping

            controls.minDistance = 5;  // Prevents zooming too close
            controls.maxDistance = 115; // Prevents zooming too far

            // Restrict panning within bounds
            controls.screenSpacePanning = false; // Panning moves parallel to ground
            const panLimits = {
                minX: -45, maxX: 45,
                minZ: -45, maxZ: 45
            };
            controls.addEventListener('change', function () {
                let pos = controls.target;
                pos.x = THREE.MathUtils.clamp(pos.x, panLimits.minX, panLimits.maxX);
                pos.z = THREE.MathUtils.clamp(pos.z, panLimits.minZ, panLimits.maxZ);
            });

            // 0.5,1,1.2
            // 0.3,0.7,1.5

            // Lights
            const hemiLight = new THREE.HemisphereLight(0xffffff, 0x000000, 0.5);
            
            scene.add(hemiLight);
            // hemiLight.castShadow = true; // ✅ Enable shadow casting
            
            const ambientLight = new THREE.AmbientLight(0xffffff, 1);

            // ambientLight.castShadow = true; // ✅ Enable shadow casting
            

            scene.add(ambientLight);

            directionalLight = new THREE.DirectionalLight(0xffffff, 1.2);
            directionalLight.position.set(200, 120, -140);

           

            directionalLight.castShadow = true; // ✅ Enable shadow casting

            // directionalLight.shadow.bias = -0.0005; // Adjust to remove black lines
            directionalLight.shadow.bias = -0.001; // try more aggressive if necessary



            if (window.innerWidth < 1024) {
                directionalLight.shadow.mapSize.width = 2048; // Higher resolution for better quality
                directionalLight.shadow.mapSize.height = 2048;
            }else{
                directionalLight.shadow.mapSize.width = 4096; // Higher resolution for better quality
                directionalLight.shadow.mapSize.height = 4096;
            }
            directionalLight.shadow.needsUpdate = true;

            directionalLight.shadow.camera.near = 1;
            directionalLight.shadow.camera.far = 400;
            directionalLight.shadow.camera.left = -60;
            directionalLight.shadow.camera.right = 60;
            directionalLight.shadow.camera.top = 60;
            directionalLight.shadow.camera.bottom = -60;
            // directionalLight.shadow.radius = 1;

            scene.add(directionalLight);


            raycaster = new THREE.Raycaster();
            raycaster.params.Points.threshold = 1; // Adjust for better small object detection
            raycaster.far = 2000; // Adjust this based on your scene scale

            mouse = new THREE.Vector2();
            window.addEventListener("click", onMouseClick);
            window.addEventListener("touchend", onTouchEnd);
            // window.addEventListener("touchend", onMouseClick);
            // Load Rhino 3DM Model

            if (window.innerWidth < 1024) {
                // loadRhinoModel("models/TiroTech/CLTopmaat_Mobile.3dm");
                loadGLTFModel("models/TiroTech/CLTopmaat.glb")
                // loadGLTFModeDraco("models/TiroTech/CLTopmaat.glb")
            }else{
                // loadRhinoModel("models/TiroTech/CLTopmaat.3dm");
                loadGLTFModel("models/TiroTech/CLTopmaat.glb")
                // loadGLTFModeDraco("models/TiroTech/CLTopmaat.glb")
            }
            

            
            animate();

            // Handle window resizing
            window.addEventListener("resize", onWindowResize);
        }

        function loadRhinoModel(url) {
            const rhinoLoader = new Rhino3dmLoader();
            rhinoLoader.setLibraryPath('https://cdn.jsdelivr.net/npm/rhino3dm@8.4.0/');
            rhinoLoader.load(url, function (object) {
                // completeTheBar();
                object.traverse(child => {
                    if (child.isMesh) {
                        // child.material = new THREE.MeshStandardMaterial({ color: 0x0088ff });
                        
                        child.castShadow = true; // ✅ Enable shadow casting for model
                        child.receiveShadow = true; // ✅ Model also receives shadows

                        if((child.name).includes("Glass")){
                            // console.log(child);
                            child.castShadow = false; // ✅ Enable shadow casting for model
                            child.receiveShadow = false; // ✅ Model also receives shadows
                            // child.defaultMaterial=child.material;
                        }else if((child.name).includes("CLTmaterial")){
                            CLTMaterial=child.material;
                        }else if((child.name).includes("hardwoodMaterial")){
                            hardwoodMaterial=child.material;
                        }
                    }
                    if (child.isMesh) {
                    const mat = child.material;

                    if (mat) {
                        mat.side = THREE.FrontSide; // Or DoubleSide if needed
                        mat.depthWrite = true;
                        mat.depthTest = true;

                        if (mat.map) mat.map.encoding = THREE.sRGBEncoding;
                        if (mat.emissiveMap) mat.emissiveMap.encoding = THREE.sRGBEncoding;

                        mat.needsUpdate = true;

                        // Optional: boost env map intensity
                        if ('envMapIntensity' in mat) mat.envMapIntensity = 1.0;
                    }
                }
                });
                
                object.rotation.x = -Math.PI / 2;
                scene.add(object);

                console.log("Rhino model loaded successfully!");
                setTimeout(function(){
                    document.getElementById("loadingScreen").style.display="none";
                },400)
                

                // createMarker(new THREE.Vector3(0, 10, 0));
                // createMarker(new THREE.Vector3(20, 15, -10));
                createMarker(new THREE.Vector3(2.046,2.5,36.813 ),"Topic0");
                createMarker(new THREE.Vector3(-9.750,2.5,9.171 ),"Topic1");
                createMarker(new THREE.Vector3(36.882,3.3,-3.004 ),"Topic2");
                createMarker(new THREE.Vector3(19.987,2.5,-41.495 ),"Topic3");
                modelLoaded = true;

            },
            function(xhr){
                // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                loadedPercentage = Math.round(((xhr.loaded / xhr.total * 100)/2));
                // console.log(loadedPercentage);

                setTimeout(function(){
                    document.getElementById("loadingBarFill").style.width=`${loadedPercentage}%`;

                    if(loadedPercentage>=50 && doneOnce==false){
                        // console.log("loading finshed");
                        if(doneOnce==false){
                            completeTheBar();
                        }
                        
                    }

                },2000)

            
                
            },
            error => console.error('Error loading model:', error)
            );
            /*
            xhr => console.log((xhr.loaded / xhr.total * 100) + '% loaded'),
                error => console.error('Error loading model:', error)

            );
            */
        }
       

        // function loadGLTFModel(url) {
        //     const loader = new GLTFLoader();

        //     loader.load(
        //         url,
        //         function (gltf) {
        //             const object = gltf.scene;

        //             object.traverse(child => {
        //                 if (child.isMesh) {
        //                     child.castShadow = true;
        //                     child.receiveShadow = true;

        //                     // Handle "Glass"
        //                     if ((child.name || "").includes("Glass")) {
        //                         child.castShadow = false;
        //                         child.receiveShadow = false;
        //                     }

        //                     // Detect specific material assignments by name
        //                     if ((child.name || "").includes("CLTmaterial")) {
        //                         CLTMaterial = child.material;
        //                     } else if ((child.name || "").includes("hardwoodMaterial")) {
        //                         hardwoodMaterial = child.material;
        //                     }
        //                     if (child.isMesh) {
        //                     const mat = child.material;
        //                     if (mat) {
        //                         mat.depthWrite = true;
        //                         mat.depthTest = true;
        //                         mat.side = THREE.FrontSide; // or DoubleSide if needed

        //                         if (mat.roughness !== undefined) mat.roughness = Math.min(0.8, mat.roughness);
        //                         mat.normalMap = null; 
        //                         // if ('envMapIntensity' in mat) mat.envMapIntensity = 0.6;

        //                         if (child.isMesh && child.material?.name === "M_wood_detailed") {
                             

        //                         // Optional: adjust UV tiling (repeat = 1 means default scale)
        //                         woodTexture.repeat.set(1, 1);
        //                         child.material = new THREE.MeshStandardMaterial({
        //                         map: woodTexture,
        //                         roughness: 0.7,
        //                         metalness: 0.0,
        //                         flatShading: false, // Set to false if texture should look smooth
        //                         });
        //                         }
        //                         if (child.isMesh && child.material?.name === "M_wood_detailed_DARKER") {
                             

        //                         // Optional: adjust UV tiling (repeat = 1 means default scale)
        //                         woodTextureDark.repeat.set(1, 1);
        //                         child.material = new THREE.MeshStandardMaterial({
        //                         map: woodTextureDark,
        //                         roughness: 0.7,
        //                         metalness: 0.0,
        //                         flatShading: false, // Set to false if texture should look smooth
        //                         });
        //                         }
        //                         if (child.isMesh && child.material?.name === "M_CLT_Top") {
                             

        //                         // Optional: adjust UV tiling (repeat = 1 means default scale)
        //                         woodCLT.repeat.set(1, 1);
        //                         child.material = new THREE.MeshStandardMaterial({
        //                         map: woodCLT,
        //                         roughness: 0.7,
        //                         metalness: 0.0,
        //                         flatShading: false, // Set to false if texture should look smooth
        //                         });
        //                         }
        //                         if (child.isMesh && child.material?.name === "M_CLT_Top_darker") {
                             

        //                         // Optional: adjust UV tiling (repeat = 1 means default scale)
        //                         woodCLTDark.repeat.set(1, 1);
        //                         child.material = new THREE.MeshStandardMaterial({
        //                         map: woodCLTDark,
        //                         roughness: 0.7,
        //                         metalness: 0.0,
        //                         flatShading: false, // Set to false if texture should look smooth
        //                         });
        //                         }
        //                         if (child.isMesh && child.material?.name === "M_CLT_Side") {
                             

        //                         // Optional: adjust UV tiling (repeat = 1 means default scale)
        //                         woodCLTSide.repeat.set(1, 1);
        //                         child.material = new THREE.MeshStandardMaterial({
        //                         map: woodCLTSide,
        //                         roughness: 0.7,
        //                         metalness: 0.0,
        //                         flatShading: false, // Set to false if texture should look smooth
        //                         });
        //                         }
                                




        //                     }
        //                     }



        //                     // if (child.name.includes("hardwoodMaterial")) {
        //                     // child.material = new THREE.MeshStandardMaterial({
        //                     //     color: 0x9e7b50, // A slightly darker tone for contrast
        //                     //     roughness: 0.7,
        //                     //     metalness: 0.0,
        //                     //     flatShading: true,
        //                     // });
        //                     // }




        //                 }
        //             });

        //             // Adjust rotation (Rhino is Z-up, Three.js is Y-up)
        //             object.rotation.x = -Math.PI / 2;

        //             scene.add(object);

        //             console.log("GLTF model loaded successfully!");
        //             setTimeout(() => {
        //                 document.getElementById("loadingScreen").style.display = "none";
        //                 completeTheBar();
        //             }, 1000);

        //             // Recreate markers
        //             createMarker(new THREE.Vector3(2.046, 2.5, 36.813), "Topic0");
        //             createMarker(new THREE.Vector3(-9.750, 2.5, 9.171), "Topic1");
        //             createMarker(new THREE.Vector3(36.882, 3.3, -3.004), "Topic2");
        //             createMarker(new THREE.Vector3(19.987, 2.5, -41.495), "Topic3");

        //             modelLoaded = true;
        //         },
        //         function (xhr) {
        //             loadedPercentage = Math.round((xhr.loaded / xhr.total * 100) / 2);

        //             setTimeout(() => {
        //                 document.getElementById("loadingBarFill").style.width = `${loadedPercentage}%`;

        //                 if (loadedPercentage >= 50 && !doneOnce) {
        //                     completeTheBar();
        //                 }
        //             }, 2000);
        //         },
        //         function (error) {
        //             console.error("Error loading GLTF model:", error);
        //         }
        //     );
        // }

        function loadGLTFModel(url) {
    const loader = new GLTFLoader();

    if (cachedGLTF) {
        // Clone the scene graph to reuse it safely
        const clonedScene = SkeletonUtils.clone(cachedGLTF.scene);
        scene.add(clonedScene);
        postModelLoad(clonedScene); // same as before
        return;
    }

    loader.load(
        url,
        function (gltf) {
            cachedGLTF = gltf; // Cache original

            const object = SkeletonUtils.clone(gltf.scene); // Work on clone
            scene.add(object);
            postModelLoad(object); // Run any setup logic on loaded model
        },
        function (xhr) {
            loadedPercentage = Math.round((xhr.loaded / xhr.total * 100) / 2);
            setTimeout(() => {
                document.getElementById("loadingBarFill").style.width = `${loadedPercentage}%`;
                if (loadedPercentage >= 50 && !doneOnce) completeTheBar();
            }, 2000);
        },
        function (error) {
            console.error("Error loading GLTF model:", error);
        }
    );
        }

        function postModelLoad(object) {
    object.traverse(child => {
        if (child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;

            const name = child.name || "";
            const mat = child.material;

            if (name.includes("Glass")) {
                child.castShadow = false;
                child.receiveShadow = false;
            }

            if (name.includes("CLTmaterial")) {
                CLTMaterial = mat;
            } else if (name.includes("hardwoodMaterial")) {
                hardwoodMaterial = mat;
            }

            if (mat) {
                mat.depthWrite = true;
                mat.depthTest = true;
                mat.side = THREE.FrontSide;
                if (mat.roughness !== undefined) mat.roughness = Math.min(0.8, mat.roughness);
                mat.normalMap = null;

                // Apply texture-based overrides
                const replaceWith = {
                    "M_wood_detailed": woodTexture,
                    "M_wood_detailed_DARKER": woodTextureDark,
                    "M_CLT_Top": woodCLT,
                    "M_CLT_Top_darker": woodCLTDark,
                    "M_CLT_Side": woodCLTSide
                };

                const tex = replaceWith[mat.name];
                if (tex) {
                    tex.repeat.set(1, 1);
                    child.material = new THREE.MeshStandardMaterial({
                        map: tex,
                        roughness: 0.7,
                        metalness: 0.0,
                        flatShading: false,
                    });
                }
            }
        }
    });

    object.rotation.x = -Math.PI / 2;

    setTimeout(() => {
        document.getElementById("loadingScreen").style.display = "none";
        completeTheBar();
    }, 1000);

    // Create markers
    createMarker(new THREE.Vector3(2.046, 2.5, 36.813), "Topic0");
    createMarker(new THREE.Vector3(-9.750, 2.5, 9.171), "Topic1");
    createMarker(new THREE.Vector3(36.882, 3.3, -3.004), "Topic2");
    createMarker(new THREE.Vector3(19.987, 2.5, -41.495), "Topic3");

    modelLoaded = true;
}

        


        // function loadGLTFModeDraco(url) {
        //     const loader = new GLTFLoader();

        //     // Setup DRACOLoader
        //     const dracoLoader = new DRACOLoader();
        //     dracoLoader.setDecoderPath('/draco/'); // Path to decoder files (e.g. /draco/)
        //     loader.setDRACOLoader(dracoLoader);

        //     loader.load(
        //         url,
        //         function (gltf) {
        //             const object = gltf.scene;

        //             object.traverse(child => {
        //                 if (child.isMesh) {
        //                     child.castShadow = true;
        //                     child.receiveShadow = true;

        //                     if ((child.name || "").includes("Glass")) {
        //                         child.castShadow = false;
        //                         child.receiveShadow = false;
        //                     }

        //                     if ((child.name || "").includes("CLTmaterial")) {
        //                         CLTMaterial = child.material;
        //                     } else if ((child.name || "").includes("hardwoodMaterial")) {
        //                         hardwoodMaterial = child.material;
        //                     }

        //                     const mat = child.material;
        //                     if (mat) {
        //                         mat.depthWrite = true;
        //                         mat.depthTest = true;
        //                         mat.side = THREE.FrontSide;
        //                         if (mat.roughness !== undefined) mat.roughness = Math.min(0.8, mat.roughness);
        //                         mat.normalMap = null;

        //                         const name = mat.name;
        //                         if (name === "M_wood_detailed") {
        //                             woodTexture.repeat.set(1, 1);
        //                             child.material = new THREE.MeshStandardMaterial({
        //                                 map: woodTexture,
        //                                 roughness: 0.7,
        //                                 metalness: 0.0,
        //                                 flatShading: false,
        //                             });
        //                         }
        //                         if (name === "M_wood_detailed_DARKER") {
        //                             woodTextureDark.repeat.set(1, 1);
        //                             child.material = new THREE.MeshStandardMaterial({
        //                                 map: woodTextureDark,
        //                                 roughness: 0.7,
        //                                 metalness: 0.0,
        //                                 flatShading: false,
        //                             });
        //                         }
        //                         if (name === "M_CLT_Top") {
        //                             woodCLT.repeat.set(1, 1);
        //                             child.material = new THREE.MeshStandardMaterial({
        //                                 map: woodCLT,
        //                                 roughness: 0.7,
        //                                 metalness: 0.0,
        //                                 flatShading: false,
        //                             });
        //                         }
        //                         if (name === "M_CLT_Top_darker") {
        //                             woodCLTDark.repeat.set(1, 1);
        //                             child.material = new THREE.MeshStandardMaterial({
        //                                 map: woodCLTDark,
        //                                 roughness: 0.7,
        //                                 metalness: 0.0,
        //                                 flatShading: false,
        //                             });
        //                         }
        //                         if (name === "M_CLT_Side") {
        //                             woodCLTSide.repeat.set(1, 1);
        //                             child.material = new THREE.MeshStandardMaterial({
        //                                 map: woodCLTSide,
        //                                 roughness: 0.7,
        //                                 metalness: 0.0,
        //                                 flatShading: false,
        //                             });
        //                         }
        //                     }
        //                 }
        //             });

        //             object.rotation.x = -Math.PI / 2;
        //             scene.add(object);

        //             console.log("GLTF model loaded successfully!");
        //             setTimeout(() => {
        //                 document.getElementById("loadingScreen").style.display = "none";
        //                 completeTheBar();
        //             }, 1000);

        //             createMarker(new THREE.Vector3(2.046, 2.5, 36.813), "Topic0");
        //             createMarker(new THREE.Vector3(-9.750, 2.5, 9.171), "Topic1");
        //             createMarker(new THREE.Vector3(36.882, 3.3, -3.004), "Topic2");
        //             createMarker(new THREE.Vector3(19.987, 2.5, -41.495), "Topic3");

        //             modelLoaded = true;
        //         },
        //         function (xhr) {
        //             loadedPercentage = Math.round((xhr.loaded / xhr.total * 100) / 2);
        //             setTimeout(() => {
        //                 document.getElementById("loadingBarFill").style.width = `${loadedPercentage}%`;
        //                 if (loadedPercentage >= 50 && !doneOnce) completeTheBar();
        //             }, 2000);
        //         },
        //         function (error) {
        //             console.error("Error loading GLTF model:", error);
        //         }
        //     );
        // }





        function completeTheBar() {
            if (doneOnce) return; // Prevent multiple executions
            doneOnce = true;

            console.log("completeTheBar percentage:", loadedPercentage);

            function incrementProgress(current) {
                if (current >= 100) return; // Stop when reaching 100%

                console.log("percentage increased:", current);

                document.getElementById("loadingBarFill").style.width = `${current}%`;

                setTimeout(() => incrementProgress(current + 1), 800); // Adjust time for smooth animation
            }

            if (loadedPercentage >= 50) {
                incrementProgress(loadedPercentage); // Start gradual increase
            }
        }

        function animate() {
            requestAnimationFrame(animate);

            
            if (isFPSMode == true) {
            
            }
            else{
                try{
                controls.update();
                }
                catch{
                    
                }
            }
            
            
            renderer.render(scene, camera);
            // composer.render();

            markers.forEach(marker => {

                const distance = camera.position.distanceTo(marker.position);
                
                // Set visibility based on distance, adjust the threshold as needed (e.g., 50 units)
                if (distance < 30) {

                    if(marker.hiddenViaFunction==false){
                        marker.visible = false;
                        marker.markerSelectable = false;
                    }

                    

                } else{
                    if(marker.hiddenViaFunction==false){
                        marker.visible = true;
                        marker.markerSelectable = true;
                    }
                    else{

                    }
                    
                }

                if (hoveredMarker === marker) {
                    updateMenuPosition(marker);
                }

            });
            // console.log("controls:",controls);
            // console.log("camera position:",camera.position);
            // console.log("controls target",controls.target);
        }

        function onWindowResize() {
            const container = document.getElementById("canvas");
            camera.aspect = container.clientWidth / container.clientHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(container.clientWidth, container.clientHeight);
        }

        function createMarker(position,name) {
            const spriteMaterial = new THREE.SpriteMaterial({
                map: createCircleTexture(),
                transparent: true,
                opacity: 0.8,
                depthTest: false,
            });
            
            const sprite = new THREE.Sprite(spriteMaterial);
            sprite.name=name;
            sprite.scale.set(3, 3, 1);
            sprite.position.copy(position);
            sprite.markerSelectable = true;
            
            sprite.renderOrder = 1;
            scene.add(sprite);
            markers.push(sprite);
            if (window.innerWidth < 1024) {
            const hitbox = new THREE.Mesh(
                new THREE.BoxGeometry(7,7,7),
                new THREE.MeshBasicMaterial({ color:0xffffff,visible: false })
            );
            hitbox.position.copy(sprite.position);
            hitbox.name=name;

            scene.add(hitbox);
            markers.push(hitbox);
            }
        }
        
        function createCircleTexture() {
            const size = 128;
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");
        
            ctx.beginPath();
            ctx.arc(size / 2, size / 2, size / 2 - 5, 0, Math.PI * 2);
            ctx.fillStyle = "rgba(192, 192, 192, 0.5)";
            ctx.fill();
            ctx.lineWidth = 12.8;
            ctx.strokeStyle = "rgba(255, 255, 255, 0.8)";
            ctx.stroke();
            
            const texture = new THREE.CanvasTexture(canvas);
            return texture;
        }
        
        function onMouseClick(event) {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
            
            raycaster.setFromCamera(mouse, camera);
            const intersects = raycaster.intersectObjects(markers);
            if (intersects.length > 0) {
                console.log(markers);
                console.log(intersects)
                // alert(intersects[0].object.name);

                const targetPos = intersects[0].object.position;
                if (intersects.length > 0) {
                    if(intersects[0].object.markerSelectable==true){
                        handleSpriteClick(intersects[0].object.name);
                    }
                }
                
            }
        }

        function onTouchEnd(event) {
            if (event.touches.length > 1 || event.changedTouches.length > 1) {
                return; // Exit function to prevent raycasting
            }
            else{
            if (event.changedTouches.length > 0) {
                // alert(event)
                let touch = event.changedTouches[0];
        
                mouse.x = (touch.clientX / window.innerWidth) * 2 - 1;
                mouse.y = -(touch.clientY / window.innerHeight) * 2 + 1;
        
                raycaster.setFromCamera(mouse, camera);
                const intersects = raycaster.intersectObjects(markers);
        
                if (intersects.length > 0) {
                    if(intersects[0].object.markerSelectable==true){
                        handleSpriteClick(intersects[0].object.name);
                    }
                }
            }
            }
        }

        function handleSpriteClick(name) {
            console.log("sprite click")

            if (name === "Topic0") {
                for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                    if(i==9){
                    document.getElementById("narrativeStepsDiv").children[i].click();
                    }
                }
            }
            else if (name === "Topic1") {
                for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                    if(i==3){
                    document.getElementById("narrativeStepsDiv").children[i].click();
                    }
                }
            } else if (name === "Topic2") {
                for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                    if(i==1){
                    document.getElementById("narrativeStepsDiv").children[i].click();
                    }
                }
            } else if (name === "Topic3") {
                for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                    if(i==10){
                    document.getElementById("narrativeStepsDiv").children[i].click();
                    }
                }
            }
        }


        init();



        modelSteps.forEach(element => {
            const button = document.createElement("button");
            button.className = "stepsButton";
            button.name = element.name;
            button.specialFunction=element.specialFunction;
            button.mainStep=element.mainStep;
            button.menu=element.menu;
            button.title=element.title;
            button.textDesription=element.textDesription; 

            if(button.mainStep==false){
                button.classList.add("buttonSmall")
            }
            button.addEventListener("click",function(){
                // console.log(button.name);
                if (isAnimating) return; // Prevents starting a new animation if one is ongoing
                isAnimating = true; // Lock further animations

                for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                
                    if(button.name == document.getElementById("narrativeStepsDiv").children[i].name){
                        currentlySelectedStep=i;
                        document.getElementById("narrativeStepsDiv").children[i].classList.add("buttonSelected")

                        gsap.to(camera.position, { duration: 1.5, x:modelSteps[i].cameraPosition.x,y:modelSteps[i].cameraPosition.y,z:modelSteps[i].cameraPosition.z,onComplete: () => isAnimating = false });
                        gsap.to(controls.target, { duration: 1.5, x:modelSteps[i].controlsTarget.x,y:modelSteps[i].controlsTarget.y,z:modelSteps[i].controlsTarget.z});
                        
                        cameraPosition={x:modelSteps[i].cameraPosition.x,y:modelSteps[i].cameraPosition.y,z:modelSteps[i].cameraPosition.z}
                        controlsTarget={x:modelSteps[i].controlsTarget.x,y:modelSteps[i].controlsTarget.y,z:modelSteps[i].controlsTarget.z}
                        
                        switchControls(modelSteps[i].controlsType,cameraPosition,controlsTarget);
                        
                        hideMenu(true,modelSteps[i].controlsType);

                        checkMarkersFirstPerson(modelSteps[i].controlsType);

                        alterMenusDisplay(button.menu);

                        document.getElementById("menuRightTop").innerHTML = button.title;
                        document.getElementById("menuRightBottom").innerHTML = button.textDesription;
                        document.getElementById("menuLeftTop").innerHTML = button.title;
                        document.getElementById("menuLeftBottom").innerHTML = button.textDesription;



                        try{
                            gsap.to(directionalLight.position, { duration: 1.5, x:modelSteps[i].sunDirection.x,y:modelSteps[i].sunDirection.y,z:modelSteps[i].sunDirection.z});
                            // directionalLight.position.x=modelSteps[i].sunDirection.x
                            // directionalLight.position.y=modelSteps[i].sunDirection.y
                            // directionalLight.position.z=modelSteps[i].sunDirection.z
                
                        }catch{
                            console.log("failed to update sun!")
                        }

                        if(modelLoaded){
                            if(button.specialFunction=="HiddingObjects"){
                                console.log(scene);
                                try{
                                for(var j=0;j<scene.children[3].children.length;j++){
                                    if(scene.children[3].children[j].name.includes("To_Hide")){
                                        // scene.children[3].children[j].material=new THREE.MeshBasicMaterial({ color:0xffffff,visible: false })
                                        scene.children[3].children[j].visible=false;
                                        scene.children[3].children[j].castShadow=false;
                                    }
                                }
                                }
                                catch{
                                    console.log("model not loaded yet");
                                }
                            }
                            else{
                                console.log(scene);
                                try{
                                for(var j=0;j<scene.children[3].children.length;j++){
                                    if(scene.children[3].children[j].name.includes("To_Hide")){
                                        // scene.children[3].children[j].material=scene.children[3].children[j].defaultMaterial
                                        scene.children[3].children[j].visible=true;
                                        if(scene.children[3].children[j].name.includes("Glass")){
                                            scene.children[3].children[j].castShadow=false;
                                        }
                                        else{
                                            scene.children[3].children[j].castShadow=true;
                                        }
                                    }
                                }
                                }
                                catch{
                                    console.log("model not loaded yet");
                                }
                            }


                            if(button.specialFunction=="AdjustMaterial"){
                                console.log(scene);
                                try{
                                for(var j=0;j<scene.children[3].children.length;j++){
                                    console.log(scene.children[3].children[j]);
                                    if(scene.children[3].children[j].name.includes("AdjustMaterial")){
                                        // scene.children[3].children[j].material=new THREE.MeshBasicMaterial({ color:0xffffff,visible: false })
                                        scene.children[3].children[j].material=new THREE.MeshStandardMaterial({
                                map: woodCLT,
                                roughness: 0.7,
                                metalness: 0.0,
                                flatShading: false, // Set to false if texture should look smooth
                                });

                                        // scene.children[3].children[j].material=new THREE.MeshStandardMaterial({
                                        // map: woodTexture,
                                        // roughness: 0.7,
                                        // metalness: 0.0,
                                        // flatShading: false, // Set to false if texture should look smooth
                                        // });
                                    }
                                }
                                }
                                catch{
                                    console.log("model not loaded yet");
                                }
                            }
                            else{
                                console.log(scene);
                                try{
                                    for(var j=0;j<scene.children[3].children.length;j++){
                                        if(scene.children[3].children[j].name.includes("AdjustMaterial")){
                                            // scene.children[3].children[j].material=new THREE.MeshBasicMaterial({ color:0xffffff,visible: false })
                                            // scene.children[3].children[j].material=hardwoodMaterial;
                                            scene.children[3].children[j].material=new THREE.MeshStandardMaterial({
                                            map: woodTexture,
                                            roughness: 0.7,
                                            metalness: 0.0,
                                            flatShading: false, // Set to false if texture should look smooth
                                            });
                                            console.log("found")
                                        }
                                    }
                                }
                                catch{
                                    console.log("model not loaded yet");
                                }
                            }
                        }


                    }else{
                        document.getElementById("narrativeStepsDiv").children[i].classList.remove("buttonSelected")
                    }
                }
            })



            document.getElementById("narrativeStepsDiv").append(button);
        });


        function switchControls(type,cameraPosition,controlsTarget) {


            if(originalControlsType==type){
                console.log("controls type stays the same");

                if (type === "FirstPerson") {

                    controls.minPolarAngle = THREE.MathUtils.degToRad(20);
                    controls.maxPolarAngle = THREE.MathUtils.degToRad(90);

                    controls.minAzimuthAngle = -Infinity;
                    controls.maxAzimuthAngle = Infinity;
                    
                    setTimeout(function(){
                        // isFPSMode = true;
                        console.log("disable controls");
                        // controls.enabled = false; // Disable OrbitControls

                        controls.minPolarAngle = THREE.MathUtils.degToRad(80); 
                        controls.maxPolarAngle = THREE.MathUtils.degToRad(91); // Prevents camera from flipping

                        let currentAzimuth = controls.getAzimuthalAngle(); 

                        // Set azimuth limits dynamically: ±10° from current angle
                        let azimuthLimit = THREE.MathUtils.degToRad(5);
                        controls.minAzimuthAngle = currentAzimuth - azimuthLimit;
                        controls.maxAzimuthAngle = currentAzimuth + azimuthLimit;

                    },1500);
                }
                else{
                    controls.minPolarAngle = THREE.MathUtils.degToRad(20);
                    controls.maxPolarAngle = THREE.MathUtils.degToRad(88);

                    controls.minAzimuthAngle = -Infinity;
                    controls.maxAzimuthAngle = Infinity;
                }
            }
            else{
                console.log("controls type changes");
                originalControlsType=type;

            
                if (type === "FirstPerson") {

                    controls.minPolarAngle = THREE.MathUtils.degToRad(20);
                    controls.maxPolarAngle = THREE.MathUtils.degToRad(90);

                    controls.minAzimuthAngle = -Infinity;
                    controls.maxAzimuthAngle = Infinity;

                    setTimeout(function(){
                        // isFPSMode = true;
                        console.log("disable controls");
                        // controls.enabled = false; // Disable OrbitControls

                        controls.minPolarAngle = THREE.MathUtils.degToRad(80); 
                        controls.maxPolarAngle = THREE.MathUtils.degToRad(91); // Prevents camera from flipping

                        let currentAzimuth = controls.getAzimuthalAngle(); 

                        // Set azimuth limits dynamically: ±10° from current angle
                        let azimuthLimit = THREE.MathUtils.degToRad(5);
                        controls.minAzimuthAngle = currentAzimuth - azimuthLimit;
                        controls.maxAzimuthAngle = currentAzimuth + azimuthLimit;

                    },1500);

                    
                   
                    
                } else {
                    isFPSMode = false;

                    camera.near = 0.1;   // Ensure the near plane is set to a reasonable value
                    camera.far = 2000; 

                    // controls = new OrbitControls(camera, renderer.domElement);
                    controls.enabled = true;
                    controls.enableDamping = true;
                    controls.minPolarAngle = THREE.MathUtils.degToRad(20);
                    controls.maxPolarAngle = THREE.MathUtils.degToRad(88);

                    controls.minAzimuthAngle = -Infinity;
                    controls.maxAzimuthAngle = Infinity;

                    controls.minDistance = 5;
                    controls.maxDistance = 115;
                    // controls.target = controlsTarget;
                }
               
                if (type === "FirstPerson") {
                    try{
                    // controls.update();
                    }
                    catch{

                    }
                }
                else{
                    controls.update();
                    markersHiddenViaClick = false;
                }

                // console.log("controls:",controls);
            }

        }


        function checkSelectedStep(){
            for(var i=0;i<document.getElementById("narrativeStepsDiv").children.length;i++){
                if(i==currentlySelectedStep){
                document.getElementById("narrativeStepsDiv").children[i].click();
                        
                }
            }
        }
        checkSelectedStep();

        leftArrowSteps.addEventListener("click",function(){
            if(isAnimating==false){
            currentlySelectedStep=currentlySelectedStep-1;
            if(currentlySelectedStep<0){
                currentlySelectedStep=modelSteps.length-1
                // console.log(modelSteps.length)
            }
            checkSelectedStep();
            }
        })
        rightArrowSteps.addEventListener("click",function(){
            if(isAnimating==false){
            currentlySelectedStep=currentlySelectedStep+1;
            if(currentlySelectedStep>modelSteps.length-1){
                currentlySelectedStep=0
            }
            checkSelectedStep();
            }
        })

        window.addEventListener("mousemove", (event) => {
            const canvas = document.getElementById("canvas");
            const rect = canvas.getBoundingClientRect();

            mouseHover.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            mouseHover.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        
            raycasterHover.setFromCamera(mouseHover, camera);
            const intersects = raycasterHover.intersectObjects(markers, true);
        
            if (intersects.length > 0) {
                const object = intersects[0].object;
                if (object !== hoveredMarker) {
                    console.log(object);
                    hoveredMarker = object;
                    showMenuAboveMarker(object);
                }
            } else {
                hideMenu(false,"NotSelected");
                hoveredMarker = null;
            }
        });

        function showMenuAboveMarker(marker) {
            if(markersHiddenViaClick==false){
                if(marker.markerSelectable==true){
                const menu = document.getElementById("menu");

                if(marker.name=="Topic0"){
                    menu.innerHTML="<span>Het Tuinhuis</span> – Persoonlijke ruimte in CLT";
                }
                if(marker.name=="Topic1"){
                    menu.innerHTML="<span>De Woning</span> – Van constructie tot interieur";
                }
                if(marker.name=="Topic2"){
                    menu.innerHTML="<span>De Workshop</span> – Start hier";
                }
                
            
                // Convert 3D position to 2D screen coordinates
                const vector = marker.position.clone().project(camera);
                const canvas = document.getElementById("canvas");
                const halfWidth = canvas.clientWidth / 2;
                const halfHeight = canvas.clientHeight / 2;
            
                // Translate to screen space
                const screenX = vector.x * halfWidth + halfWidth;
                const screenY = -vector.y * halfHeight + halfHeight;
            

                // Position the menu slightly above the marker
                menu.style.left = `${screenX - menu.offsetWidth/2}px`;
                menu.style.top = `${screenY - menu.offsetHeight*1.4}px`; // Offset to appear above

                if(marker.name=="Topic3"){
                    menu.innerHTML="<span>Welkom bij CLTopmaat</span>";
                    menu.style.display = "none";
                }else{
                    menu.style.zIndex = "1000"; // Ensure it's above the sprite
                    menu.style.display = "block";

                }


                }
            }
        }

        function updateMenuPosition(marker) {
            const menu = document.getElementById("menu");
        
            if (!menu) return;
            
            if(markersHiddenViaClick==false){
                if(marker.markerSelectable==true){
                // Convert 3D position to 2D screen coordinates
                const vector = marker.position.clone().project(camera);
                const canvas = document.getElementById("canvas");
                const halfWidth = canvas.clientWidth / 2;
                const halfHeight = canvas.clientHeight / 2;
            
                // Calculate screen position
                const screenX = vector.x * halfWidth + halfWidth;
                const screenY = -vector.y * halfHeight + halfHeight;
            
                // Adjust menu position to be above the pin
                if(marker.name=="Topic3"){
                    menu.innerHTML="<span>Welkom bij CLTopmaat</span>";
                    menu.style.display = "none";
                }else{
                    menu.style.zIndex = "1000"; // Ensure it's above the sprite
                    menu.style.display = "block";

                }
                

                // Position the menu slightly above the marker
                menu.style.left = `${screenX - menu.offsetWidth/2}px`;
                menu.style.top = `${screenY - menu.offsetHeight*1.3}px`; // Offset to appear above
                }
            }
        }


        function hideMenu(isClick,clickedMarkerType) {
            if(isClick){
                if(clickedMarkerType == "FirstPerson"){
                    markersHiddenViaClick = true;
                }
                else{
                    markersHiddenViaClick = false;
                }
            }
            const menu = document.getElementById("menu");
            menu.style.display = "none";
        }

        function checkMarkersFirstPerson(type){

            if(type === "FirstPerson"){
                markersHiddenViaClick=true;
            }
            else{
                markersHiddenViaClick=false;
            }

            markers.forEach(marker => {
                
                if(type === "FirstPerson"){
                    marker.hiddenViaFunction = true;
                    marker.visible = false;
                    marker.markerSelectable = false;
                } else {
                    marker.hiddenViaFunction = false;
                    marker.visible = true;
                    marker.markerSelectable = true;
                }

            
            });
        }

        function alterMenusDisplay(menusToDisplay){

            if(menusToDisplay=="NoMenus"){
                // document.getElementById("menuLeftWrapper").style.display="none";
                // document.getElementById("menuRightWrapper").style.display="none";

                document.getElementById("menuLeftWrapper").classList.remove("show");
                document.getElementById("menuRightWrapper").classList.remove("show");
            }
            else if(menusToDisplay=="RightMenu"){
                // document.getElementById("menuLeftWrapper").style.display="none";
                // document.getElementById("menuRightWrapper").style.display="block";

                document.getElementById("menuLeftWrapper").classList.remove("show");
                document.getElementById("menuRightWrapper").classList.add("show");
            }
            else if(menusToDisplay=="LeftMenu"){
                // document.getElementById("menuLeftWrapper").style.display="block";
                // document.getElementById("menuRightWrapper").style.display="none";

                document.getElementById("menuLeftWrapper").classList.add("show");
                document.getElementById("menuRightWrapper").classList.remove("show");
            }

        }